import * as React from 'react';
import Ellipsis from '../Ellipsis';
const TextBase = React.forwardRef(({ dataHook, className, children, ellipsis, ellipsisProps = {}, type, ...props }, ref) => {
    const { maxLines = 1 } = ellipsisProps;
    const element = () => React.createElement(type, {
        ref,
        ...props,
        'data-hook': dataHook,
        className,
        children,
    });
    return ref ? (element()) : (React.createElement(Ellipsis, { maxLines: ellipsis ? maxLines : 0 }, element()));
});
export default TextBase;
//# sourceMappingURL=TextBase.js.map